module.exports = __webpack_public_path__ + "img/symbol_9.365e232e.png";